export var extractAri = function extractAri(jsonLd) {
  if (jsonLd['atlassian:ari']) {
    return jsonLd['atlassian:ari'];
  }
};